
    import { PageRequest } from "@/store/shared/entity";
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins,appConst,PageResultListMixins,$util } from "@/lib"; 

    class  PageLogisticscostRequest extends PageRequest{
        ownerId:number;
        shippingNumber:string;
        customerId:number;
        shipmentDate=[new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0,10),new Date(new Date().setMonth(new Date().getMonth() + 3)).toISOString().slice(0,10)];
        logisticsConfirmStatus:string;
        logisticsName:string;
        salesType:string;
        constructor() {
        super();
        this.salesType = appConst.salesType.exportSales;// 默认出口
        }
    }

    @Component({
 name:"logisticscost.list",
 components: {}
    })
    export default class LogisticscostView extends  Mixins(PageResultBaseMixins,PageResultModalMixins,PageResultListMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageLogisticscostRequest(),
            queryAction:"shipment/logisticscost/getAll",
            isAutoQuery: true,
            selection: true,
            cols:this.columns,
        }
        selectedRows: any[] = [];
        async activated() {
         
         }

        get columns(){
            return [
                {
                  title: this.L("app.DeclareCustoms.ShippingNumber"),
                  key: "shippingNumber",
                  width:150
                }, 
                {
                  title: this.L("app.DeclareCustoms.CustomerName"),
                  key: "customerName",
                  width:300
                }, 
                 this.$util.render.dateColumn(
                 "app.DeclareCustoms.ShipmentDate",
                 "shipmentDate",
                 { width: 150 }
                ),
                { title:this.L('app.LogisticsCost.LogisticsNameAndAmount'), key:'logisticsNameAndAmount', minWidth:600,
                    render: (h, {row}) => {
                        let list = row.recordDto;
                        let result = [];
                            if (list) {
                             list.forEach((item, index)=> { 
                                 if(item.currency=='USD'){
                                    result.push(h('span', {},
                                    [h('span',item.logisticsName+" "+'-'+' '+'$'+this.$util.format.amount(item.amount)+""),
                                    h('Tooltip',{props: {transfer: true }, },[h('span',{style:"background-color:#87cefa"}, item.remark!=null?'备注:'+item.remark:""),h('span', {
                                    slot: 'content',
                                    style: {
                                    whiteSpace: 'normal',
                                    }},item.remark!=null?'备注:'+item.remark:"")])
                                    ]))
                                    result.push(h('br'))
                                   }
                                   else{
                                    result.push(h('span', {},
                                    [h('span',item.logisticsName+" "+'-'+' '+'￥'+this.$util.format.amount(item.amount)+""),
                                    h('Tooltip',{props: {transfer: true }, },[h('span',{style:"background-color:#87cefa"}, item.remark!=null?'备注:'+item.remark:""),h('span', {
                                    slot: 'content',
                                    style: {
                                    whiteSpace: 'normal',
                                    }},item.remark!=null?'备注:'+item.remark:"")])
                                    ]))
                                    result.push(h('br'))
                                   }
                                
                         });
                       }
                       return h("div", {class:"ivu-table-cell-tooltip-content"}, result)
                   }
                 },
                this.$util.render.codeColumn(
                "app.DeclareCustoms.Status",
                "logisticsConfirmStatus",
                () =>
                 this.getCodeListByCategory(
                 appConst.codeCategory.confirmStatus
                ),
                {width:100}
      ),
                this.$util.render.actions(this.colButtons, ()=>{return {fixed: "right"}})
            ]
        }

        colButtonCheck = (row) => {
            return !row.isStatic;
        }

        get colButtons():ActionButtonConfig[]{ 
        return [

       {
           label: "app.FactoryCost.Registration",
           permission: "RIMS.LogisticsCost.Registration",
           check:row => {
                    return row.logisticsConfirmStatus != appConst.confirmStatus.confirmed&&row.chargeUserId==this.currentUser.id;
                },
           callback: async (row:any) => {
           this.push("logisticsCost.registration", {id:row.declareCustomsId});
          }                                         
       }, 
       { label: "app.FactoryCost.Confirm", permission: "RIMS.LogisticsCost.Confirm",
                check:row => {
                    return row.logisticsConfirmStatus === appConst.confirmStatus.confirming&&row.chargeUserId==this.currentUser.id;
                },
                callback:async row => {
                    var i=0;
                    row.recordDto.forEach(element => {
                        if(element.amount===0){
                            this.$Modal.confirm({
                        title: this.L("app.LogisticsCost.ConfirmWarning"),
                        content: this.L("app.LogisticsCost.ConfirmWarnings"),
                        onOk:()=>{
                            this.confirm(row);
                        },
                        onCancel:()=>{
                            return;
                        }
                    });
                        }
                        else{
                            i++;
                        }
                        
                    })
                    if(i==row.recordDto.length){
                         this.confirm(row);
                    }
                 
                    
                    
                },
                needPoptip: true,
                popTipContent: this.L("app.FactoryCost.TipConfirm")
        },
        {
           label: "app.FactoryCost.Detail",
           permission: "RIMS.LogisticsCost.Detail",
           callback: async (row:any) => {
              
           this.push("logisticscost.detail", {id:row.declareCustomsId});
          }                                         
       }, 
            {
                label: "app.Action.Revoke",
                permission: "RIMS.LogisticsCost.Revoke",
                callback: async (row:any, type?:string) => {
                    await this.$store.dispatch({type: type, data: {id: row.declareCustomsId}});
                    this.$Message.success(this.L("app.Tip.RevokedSuccessfully"));
                    this.refresh();
                },
                check: (row) => {
                    return row.logisticsConfirmStatus === appConst.confirmStatus.confirmed;
                },
                needPoptip: true,
                popTipContent: this.L("app.Tip.RevokeConfirm"),
                type: "shipment/logisticscost/revoke"
            }
        ]
    }
    async confirm(data){
        await this.$store.dispatch({
            type: "shipment/logisticscost/confirm",
            data: data
        });
        this.$Message.success(this.L("Tip.SubmittedSuccessfully"));
        this.refresh();
    }

    onSelectionChange(selection: any[]) {
        this.selectedRows = selection;
    }

    get canBatchConfirm() {
        return this.selectedRows.length > 0;
    }

    async batchConfirm() {
        
        if (!this.selectedRows || this.selectedRows.length === 0) {
            this.$Message.warning(this.L("app.FactoryCost.PleaseSelectAtLeastOneItem"));
            return;
        }

        let hasZeroAmount = false;
        this.selectedRows.forEach(row => {
            row.recordDto.forEach(element => {
                if (element.amount === 0) {
                    hasZeroAmount = true;
                }
            });
        });

        if (hasZeroAmount) {
            this.$Modal.confirm({
                title: this.L("app.LogisticsCost.ConfirmWarning"),
                content: this.L("app.LogisticsCost.ConfirmWarnings"),
                onOk: async () => {
                    await this.doBatchConfirm();
                },
                onCancel: () => { return; }
            });
        } else {
            await this.doBatchConfirm();
        }
    }

    async doBatchConfirm() {
        const ids = this.selectedRows.map(row => row.declareCustomsId);
        await this.$store.dispatch({
            type: "shipment/logisticscost/batchConfirm",
            data: { declareCustomsIds: ids }
        });
        this.$Message.success(this.L("Tip.SubmittedSuccessfully"));
        this.refresh();
    }

        async created(){
             if(this.currentUser.id==10){
            this.data.model.ownerId = this.currentUser.id;
             }
            await this.$store.dispatch("system/customer/getCustomerList");
         await this.$store.dispatch("system/logistics/getLogisticsList");
         await this.$store.dispatch({
                 type:'system/userassignment/getUser'
        })
           
        }
        get salesTypeText() {
       return this.data.model.salesType == appConst.salesType.domesticSales ? "￥" : "￥";
     }
 
        reset(){
            this.data.model = new PageLogisticscostRequest();
             if(this.currentUser.id==10){
               this.data.model.ownerId = this.currentUser.id;
             }
        }
        
        
         total(){
             let tt=this.$store.state.shipment.logisticscost.allTotal
             if(tt==null)
             {
                 tt=this.salesTypeText+"NA";
                
             }
             else{
                tt=this.salesTypeText+this.$util.format.amount(tt);
             }
              return  tt;
            
        }
        //客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }
  get logisticsList() {
    return this.$store.state.system.logistics.logisticsLists;
  }
   get userList() {
    return this.$store.state.system.userassignment.userList;
  }
  
  // 销售类型列表
  get salesTypeList() {
    return this.getCodeListByCategory(appConst.codeCategory.salesType)
  }
  //状态
  get statusList() {
    return this.getCodeListByCategory(
      appConst.codeCategory.confirmStatus
    );
  }
  get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
    }
